import { addMinutes, subMinutes } from "date-fns";

// Mostly works, barring some edge cases. Best options for date-fns
// https://github.com/date-fns/date-fns/issues/1401#issuecomment-578580199
export const asUTC = (value: Date) =>
  value.toString().includes("+")
    ? subMinutes(value, value.getTimezoneOffset())
    : addMinutes(value, value.getTimezoneOffset());

export const fromUTC = (value: Date) =>
  value.toString().includes("+")
    ? addMinutes(value, value.getTimezoneOffset())
    : subMinutes(value, value.getTimezoneOffset());
